import { createRouterTransport } from "@connectrpc/connect";
import { WalletService } from "schema/gen/es/chiikipoint/wallet/v2/service_connect.js";
import {
  handleApplyCampaign,
  handleApplyChargeBonusCampaign,
  handleApplyRepresentativeSignupCampaign,
  handleApplySelfRepresentativeSignupCampaign,
  handleCreateMyInviter,
  handleGetMyCampaignStatuses,
  handleGetMyInvitation,
  handleGetRepresentations,
} from "./wallet-service-campaign";
import {
  handleAddCreditCard,
  handleChargeByCreditCard,
  handleCreateMypaymentChargeOrder,
  handleDeleteCreditCard,
  handleGetAvailableAwaitingPaymentMypaymentChargeOrder,
  handleGetAvailableCardChargeOrder,
  handleGetCreditCards,
  handleSetDefaultCreditCard,
} from "./wallet-service-charge";
import {
  handleConsumeDistributionCode,
  handleConsumeStandaloneDistributionCode,
  handleGetDistributionCodeDetail,
  handleGetStandaloneDistributionCodeDetail,
} from "./wallet-service-distribution";
import {
  handleCreateHokkaidoR8HouseholderCodeUseAsWalletBalance,
  handleGetHokkaidoR8HouseholderCodeStatus,
  handleGetHokkaidoR8HouseholderMynaApplication,
  handleHandleHokkaidoR8HouseholderMynaApplicationCallback,
  handleStartHokkaidoR8HouseholderMynaApplication,
} from "./wallet-service-hokkaido";
import {
  handleGetAllCities,
  handleGetCategories,
  handleGetFundSourceFilterMap,
  handleGetMyBalances,
  handlePay,
} from "./wallet-service-other";
import { handleGetStore, handleGetStores } from "./wallet-service-stores";
import {
  handleGetMyTransaction,
  handleGetMyTransactions,
} from "./wallet-service-transactions";
import {
  handleAcceptTransferCode,
  handleUpsertTransferCode,
} from "./wallet-service-transfer";

export const walletServiceMockTransport = createRouterTransport(
  ({ service }) => {
    service(WalletService, {
      getMyBalances: handleGetMyBalances,
      getMyTransactions: handleGetMyTransactions,
      getMyTransaction: handleGetMyTransaction,
      getCategories: handleGetCategories,
      getAllCities: handleGetAllCities,
      getFundSourceFilterMap: handleGetFundSourceFilterMap,
      getStores: handleGetStores,
      getStore: handleGetStore,
      getMyInvitation: handleGetMyInvitation,
      createMyInviter: handleCreateMyInviter,
      applyCampaign: handleApplyCampaign,
      applyChargeBonusCampaign: handleApplyChargeBonusCampaign,
      getMyCampaignStatuses: handleGetMyCampaignStatuses,
      pay: handlePay,
      upsertTransferCode: handleUpsertTransferCode,
      acceptTransferCode: handleAcceptTransferCode,
      consumeDistributionCode: handleConsumeDistributionCode,
      getDistributionCodeDetail: handleGetDistributionCodeDetail,
      getStandaloneDistributionCodeDetail:
        handleGetStandaloneDistributionCodeDetail,
      consumeStandaloneDistributionCode:
        handleConsumeStandaloneDistributionCode,
      getCreditCards: handleGetCreditCards,
      addCreditCard: handleAddCreditCard,
      chargeByCreditCard: handleChargeByCreditCard,
      createMypaymentChargeOrder: handleCreateMypaymentChargeOrder,
      getAvailableAwaitingPaymentMypaymentChargeOrder:
        handleGetAvailableAwaitingPaymentMypaymentChargeOrder,
      getAvailableCardChargeOrder: handleGetAvailableCardChargeOrder,
      deleteCreditCard: handleDeleteCreditCard,
      setDefaultCreditCard: handleSetDefaultCreditCard,
      getRepresentations: handleGetRepresentations,
      applySelfRepresentativeSignupCampaign:
        handleApplySelfRepresentativeSignupCampaign,
      applyRepresentativeSignupCampaign:
        handleApplyRepresentativeSignupCampaign,
      getHokkaidoR8HouseholderCodeStatus:
        handleGetHokkaidoR8HouseholderCodeStatus,
      createHokkaidoR8HouseholderCodeUseAsWalletBalance:
        handleCreateHokkaidoR8HouseholderCodeUseAsWalletBalance,
      getHokkaidoR8HouseholderMynaApplication:
        handleGetHokkaidoR8HouseholderMynaApplication,
      startHokkaidoR8HouseholderMynaApplication:
        handleStartHokkaidoR8HouseholderMynaApplication,
      handleHokkaidoR8HouseholderMynaApplicationCallback:
        handleHandleHokkaidoR8HouseholderMynaApplicationCallback,
    });
  },
  {
    transport: {
      interceptors: [
        (next) => async (req) => {
          // 通信遅延をシミュレート
          await new Promise((resolve) => setTimeout(resolve, 300));
          return next(req);
        },
      ],
    },
  },
);
